import {DatePicker} from "element-ui"
export default {  
  mixins: [DatePicker],
  props:{
    pickerOptions:{
      type: Object,
      default: ()=>{
        return  {
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            }
          }, {
            text: '昨天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', date);
            }
          }, {
            text: '一周前',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            }
          },
          {
            text: "三十天前",
            onClick(picker){
              const date = new Date()
              date.setTime(date.getTime() - 3600*1000*24*30);
              picker.$emit('pick',date)
            }
          },
          {
            text: "九十天前",
            onClick(picker){
              const date = new Date()
              date.setTime(date.getTime() - 3600*1000*24*90);
              picker.$emit('pick',date)
            }
          },
          {
            text: "本年开始",
            onClick(picker){
              const date =new Date()
              date.setMonth(0)
              date.setDate(1)
              picker.$emit('pick',date)
            }
          },
          {
            text:'本年末',
            onClick(picker){
              const date = new Date()
              date.setMonth(11)
              date.setDate(31)
              picker.$emit('pick',date)
            }
          }
        ]
        }
      }
    },
  }
}